import type { DynamicQuestionAnswerValue } from 'src/components/molecules';
import type { SaveAnswerInputType } from 'src/graphql/generated';
import {
  buildUploadedFilesFromEvidenceState,
  stringifyDynamicQuestionUploadedFiles,
} from 'src/utils/dynamicQuestionUploadedFiles';

function resolveFileUploadAnswerText(
  value: DynamicQuestionAnswerValue,
): string | undefined {
  if (value.evidenceUploadFiles && value.evidenceUploadFiles.length > 0) {
    return stringifyDynamicQuestionUploadedFiles(
      buildUploadedFilesFromEvidenceState(value.evidenceUploadFiles),
    );
  }
  if (value.uploadedFiles && value.uploadedFiles.length > 0) {
    return stringifyDynamicQuestionUploadedFiles(value.uploadedFiles);
  }
  if (value.fileNames && value.fileNames.length > 0) {
    return value.fileNames.join('; ');
  }
  return undefined;
}

export function mapAnswersToSaveInput(
  answers: Record<string, DynamicQuestionAnswerValue>,
): SaveAnswerInputType[] {
  return Object.entries(answers)
    .filter(
      ([questionId, value]) =>
        !questionId.startsWith('questionText:') &&
        value != null &&
        Object.keys(value).length > 0,
    )
    .map(([questionId, value]) => {
      const fileUploadText = resolveFileUploadAnswerText(value);
      return {
        questionId,
        value: {
          text: fileUploadText ?? value.text,
          selectedOptionId: value.selectedOptionId,
          selectedOptionIds: value.selectedOptionIds,
          dataGridRows: value.dataGridRows,
          textValues: value.textValues,
        },
      };
    });
}
